import { MappingDefinition } from './organization';

export interface CompanyIntegration {
  id: number;
  integrationType: string;
  lastRun?: Date;
  frequency: string;
  isActive: boolean;
}

export interface CreateIntegration {
  integrationType: string;
  trigger: TriggerSettings;
  config: string;
  companyId: number;
  mappingDefinitions: MappingDefinition[];
}

export interface EditIntegration extends CreateIntegration {
  id: number;
}

export interface RunIntegrationModel {
  companyId: number;
  integrationId: number;
}

export interface IntegrationFields {
  providerFields: ProviderFields[]
}

export interface ProviderFields {
  name: string;
  type: string;
  fields: SpecificIntegrationFields[]
}

export interface SpecificIntegrationFields{
  integrationId?: number;
  fields: string[]
}

export interface CronSchedule {
  cronExpression: string;
  intervalUnit?: 'Week' | 'Month' | 'Day';
  intervalValue?: number;
  timeZone: string;
  referenceDate: Date;
}

export interface TriggerSettings {
  type: TriggerType;
  schedule: CronSchedule;
}

export enum TriggerType{
  Manual = 'Manual',
  Recurring = 'Recurring'
}

export enum IntegrationTypes {
  AlexisHr = 'AlexisHr',
  MergeDev = 'MergeDev',
  AzureAd = 'AzureAd',
  HaileyHr = 'HaileyHr',
  Twine = 'Twine',
  AutomaticFileImport = 'AutomaticFileImport'
}

export interface IntegrationValidationResult {
  isValid: boolean;
  message: string;
}
